import { ILanguages, TLanguage } from "../interfaces/default.interface";

export enum ELanguages {
  UZ = "UZ",
  RU = "RU",
  UZ_CYRL = "UZ-CYRL",
  EN = "EN",
}

export const mappingLanguageList: ILanguages = {
  uz: ELanguages.UZ,
  crl: ELanguages.UZ_CYRL,
  ru: ELanguages.RU,
};
export const LanguageArray: TLanguage[] = ["ru", "crl", "uz"];
